import { render, staticRenderFns } from "./EditableHeaderCell.vue?vue&type=template&id=0610c4b9&"
import script from "./EditableHeaderCell.vue?vue&type=script&lang=js&"
export * from "./EditableHeaderCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports